import React, { useEffect } from 'react'
import '../index.scss'
import { observer } from 'mobx-react'
import InputShareEdit from '@Components/Fields/InputShareEdit'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { canAmend } from '@App/helpers/permission'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface AdminPublisherCardEditableProps {
    data: PublisherModel
    parentOP: OriginalPublisherModel
    shareError: string
    onShareChange?(): void
}

const AdminPublisherCardEditable = ({ data, parentOP, shareError, onShareChange }: AdminPublisherCardEditableProps) => {
    const { workStore } = React.useContext(StoresContext)
    const [publisherShare, setPublisherShare] = React.useState<number>(data.publisherShare ? data.publisherShare : 0)

    const setAPToDraft = (shares: number) => {
        const workDraftFromLocal = workStore.workDraftLocal
        const editingAP = data
        const editingAPid = data.localId

        if (!workDraftFromLocal || !editingAPid || !parentOP || !editingAP) {
            return
        }

        const updatedAP: PublisherModel = {
            localId: data.localId,
            ipId: editingAP.ipId,
            amend: true,
            publisherName: data.publisherName,
            ipiNumber: data.ipiNumber,
            publisherShare: shares,
        }

        const indexOfAP = parentOP.administratorPublishers.map((ap: PublisherModel) => ap.localId).indexOf(editingAPid)

        const updatedApArray = setItemToArrayByIndex(parentOP.administratorPublishers, +indexOfAP, updatedAP)

        const updatedParentOp = {
            ...parentOP,
            administratorPublishers: updatedApArray,
        }

        const indexOfOp = workDraftFromLocal.originalPublishers
            .map((op: OriginalPublisherModel) => op.localId)
            .indexOf(parentOP.localId)

        const updatedOpArray = setItemToArrayByIndex(workDraftFromLocal.originalPublishers, +indexOfOp, updatedParentOp)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOpArray,
        }
        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const getShares = (shares: number) => {
        setPublisherShare(shares)
        setAPToDraft(shares)
        if (onShareChange) {
            onShareChange()
        }
    }

    const stepValidator = () => {
        // passing true here to preserve any potential old logic behavior
        workStore.setWizardStepValidation(true)
    }

    useEffect(() => {
        stepValidator()
    }, [])

    return (
        <div className="admin-publisher-card">
            <div className="head">
                <p className="bold">{data.publisherName}</p>
            </div>
            <div className="content">
                <p className="small">
                    IPI: <strong>{data.ipiNumber}</strong>
                </p>
                {canAmend(data.amend) && (
                    <InputShareEdit
                        onChange={getShares}
                        value={publisherShare}
                        shareError={shareError}
                        label="Publisher share:"
                    />
                )}
            </div>
        </div>
    )
}

export default observer(AdminPublisherCardEditable)
